import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../common/containers/icon';
const OptionNestedPickerFieldBack = ({
  isShown: _isShown = true,
  title,
  onBack
}) => _isShown ? /*#__PURE__*/React.createElement("div", {
  className: "t-onpfb-back",
  onClick: onBack,
  onKeyDown: onBack,
  tabIndex: 0,
  role: "button",
  style: {
    cursor: 'pointer'
  }
}, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
  glyph: "chevron-left"
}), title)) : null;
OptionNestedPickerFieldBack.propTypes = {
  isShown: PropTypes.bool,
  title: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired
};
export default OptionNestedPickerFieldBack;